import React from "react";
import '../css/Style.css';
function Seasonal(){
    return(<>
         <div className="container-fluid bg-secondary mb-5">
            <div className="container py-3">
            <div class="d-flex justify-content-between ">
              <div className="fw-bold text-white  " >SEASONAL</div>
              <div  className="fw-bold text-white ">Home > Seasonal</div>
                </div>
            </div>
         </div>

         <div className="container mt-5 mb-5">

         <div className="row mb-5">
          <div className="about_title">
            <p className="fw-bold">VARITY OF FRUITS</p>
            <h3 className="fw-bold bg_text">Seasonal Fruitss</h3>
            <div class="fancy-border"></div>
          </div>
        </div>

        <div class="row">
  <div class="col-4">
    <nav id="navbar-example3" class="h-100 flex-column align-items-stretch pe-4 border-end">
      <nav class="nav nav-pills flex-column">
        <a class="nav-link" href="#item-1">Summer Fruits</a>
       
        <a class="nav-link" href="#item-2">Monsoon Fruits:</a>
        <a class="nav-link" href="#item-3">Winter Fruits:</a>
       
      </nav>
    </nav>
  </div>

  <div class="col-8">
    <div data-bs-spy="scroll" data-bs-target="#navbar-example3" data-bs-smooth-scroll="true" class="scrollspy-example-2" tabindex="0">
      <div id="item-1" className="text-start p-3">
      
      <h4 className="bg_text"> Mango (Aamba)</h4> 
      <div class="fancy-border_left"></div>
      <p className="p-2 text-muted"> Mangoes are widely loved and come in various varieties. Odisha produces varieties like Dashahari, Langra, and others.
Additional Info: Mangoes are a significant part of Odia cuisine, and they are used in various dishes and desserts.</p>

  <h4 className="bg_text">Jackfruit (Panasa)</h4>
  <div class="fancy-border_left"></div>
  <p className="p-2 text-muted">Jackfruit is a large, green, spiky fruit with a sweet and distinctive flavor.
Additional Info: It is often used in both ripe and unripe forms in various Odia dishes.</p>

  <h4 className="bg_text">Papaya (Amrutabhanda)</h4>
  <div class="fancy-border_left"></div>
  <p className="p-2 text-muted"> Papaya is a tropical fruit with orange flesh and a sweet taste.
Additional Info: It is not only consumed as a fruit but is also used in salads and desserts.</p>
      </div>
     
      <div id="item-2 " className="text-start p-3">
      <h4 className="bg_text"> Guava (Amrutaballi)</h4> 
      <div class="fancy-border_left"></div>
      <p className="p-2 text-muted">  Guava is a round or pear-shaped fruit with green or yellow skin and sweet, fragrant flesh.
Additional Info: It is rich in Vitamin C and is often eaten as a snack or used in fruit salads.</p>

  <h4 className="bg_text">Jamun (Jamku)</h4>
  <div class="fancy-border_left"></div>
  <p className="p-2 text-muted"> Jamun, also known as black plum, is a small, purple fruit with a tangy taste.
Additional Info: It is believed to have several health benefits and is used in making jams and juices.</p>

  
      </div>
      <div id="item-3" className="p-3 text-start">
      <h4 className="bg_text"> Orange (Kamala)</h4> 
      <div class="fancy-border_left"></div>
      <p className="p-2 text-muted"> Oranges are citrus fruits with a sweet and tangy flavor.
Additional Info: They are a good source of Vitamin C and are consumed fresh or as juice.</p>

  <h4 className="bg_text">Guava (Amrutaballi)</h4>
  <div class="fancy-border_left"></div>
  <p className="p-2 text-muted"> Guava is also a winter fruit in some regions of Odisha.
Additional Info: Guavas are available in different varieties and are rich in dietary fiber.</p>

  <h4 className="bg_text">Cashew (Kaju)</h4>
  <div class="fancy-border_left"></div>
  <p className="p-2 text-muted">Cashew is a nut that grows on the cashew tree. The cashew apple is also edible.
Additional Info: Cashew nuts are used in various dishes, and the cashew apple can be eaten fresh or used in beverages..</p>
      </div>
      
    </div>
  </div>
</div>
 </div>


         <div className="container mb-5 mt-5">
         <div class="card text-bg-dark">
          <img src="https://vagadagro.in/wp-content/uploads/2023/02/Benefits-of-eating-seasonal-Fruits-List-of-seasonal-fruits-1170x614.jpeg" class="card-img" alt="..."/>
          <div class="card-img-overlay">
          </div>
        </div>
        <div  className="swasonal_fruit mt-5 mb-3 text-start">
        <h4 className="bg_text">Nutritional quality</h4>
  <div class="fancy-border_left"></div>
  <p className="p-2 text-muted">Eating seasonal foods during their peak season results in a higher concentration of nutrients compared to when they are not in season.  Seasonal produce is picked at its peak, when it is most nutrient-dense.</p>
        </div>

        <div  className="swasonal_fruit mt-3 mb-3 text-start">
        <h4 className="bg_text">Flavor</h4>
  <div class="fancy-border_left"></div>
  <p className="p-2 text-muted">Seasonal foods are allowed to ripen naturally and are harvested at the optimal time. On the other hand, off-season produce is often artificially ripened using chemicals and gases, leading to a decreased taste and nutritional value compared to naturally ripened seasonal produce. So, seasonal produce has the best flavor because it is ripened naturally on the vine or tree, rather than being picked earlier..</p>
        </div>

        <div  className="swasonal_fruit mt-3 mb-3 text-start">
        <h4 className="bg_text">Cost savings</h4>
  <div class="fancy-border_left"></div>
  <p className="p-2 text-muted">Seasonal produce is typically less expensive because it is available in bulk in market during its peak growing season. So because of increased in supply and competition in sellers, market rates are minimum. In off-season farming produce is typically sourced by imported or grown by hi-tech farming methods in greenhouses, which can add to the cost due to transportation and production expenses.</p>
        </div>

        <div  className="swasonal_fruit mt-3 mb-3 text-start">
        <h4 className="bg_text">Environmentally friendly</h4>
  <div class="fancy-border_left"></div>
  <p className="p-2 text-muted">Eating seasonal produce reduces the carbon footprint of transportation and storage as it is reduces greenhouse gas emissions by eliminating the need for artificial heating or lighting required to grow it, storage it and transports it from long distance thus saving high-energy input.

</p>
        </div>

        

         </div>
    </>);
}
export default Seasonal;
